module.exports = __webpack_public_path__ + "static/Hannah-a3e10b71919c14f27ed811600675fe27.png";